module.exports = __webpack_public_path__ + "img/microbialGarden-min (1).545a8534.png";